import React, { useEffect, useRef, useState } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import config from '../configuration/config';
import { getData, User_Data_Key } from "../utils/localStorageManager";
import { useSelector, useDispatch } from 'react-redux';
import { addNotification, markAsRead, markAllAsRead, addpulkNotification, clearNotifications, tryAddNotification } from '../_redux/slices/notificationSlice';
import { toast } from 'react-toastify';
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import './NotificationInbox.scss';
import axios from "axios";
import {
    getReadNotifications,
    saveReadNotification,
    saveAllReadNotifications,
} from '../utils/notificationStorage';
// تخصيص الـ NotificationComponent
const NotificationComponent = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t: trans, i18n } = useTranslation(["user"]);
    let lang = (i18n.language || 'ar');
    const dir = lang == "ar" ? "right" : "left";
    const notifications = useSelector((state) => state.notifications);

    const unreadCount = notifications.filter(n => !n.read).length;

    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);
    const audioRef = useRef(null);
    const [iconVibrate, setIconVibrate] = useState(true);  // لحالة الاهتزاز البصري
    const initialNotifications = () => {
        try {
            const secretKey = getData('secretKey');
            if (secretKey) {
                axios.post(
                    `${config.controllURL}${lang}/api/Pages/SiteusernotificationsFunc`,
                    {
                        "id": secretKey
                    }
                ).then(response => {
                    const result = response.data;

                    if (result && result.length > 0) {
                        const readIds = getReadNotifications();
                        const updated = result.map(n => ({
                            ...n,
                            read: readIds.includes(n.NotifyId)
                        }));

                        dispatch(addpulkNotification(updated));
                    }

                }).catch(error => {
                    console.log(error);
                })
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        initialNotifications();
    }, []);
    // useEffect(() => {
    //     const setupConnection = async () => {
    //         try {
    //             const rawUserData = getData(User_Data_Key, true);
    //             if (!rawUserData) return;

    //             const cleanData = JSON.parse(rawUserData);
    //             const user_id = cleanData.id.toString().split('_')[1];
    //             if (!user_id) return;
    //             const connection = new HubConnectionBuilder()
    //                 .withUrl(`${config.controllURL}notificationHub?userId=${user_id}`)
    //                 .withAutomaticReconnect()
    //                 .build();

    //             await connection.start();
    //             console.log("✅ SignalR Connected");

    //             connection.on("ReceiveNotification", async (notification) => {
    //                 console.log("📩 SignalR ReceiveNotification:", notification);

    //                 try {
    //                     const parsed = typeof notification === 'string' ? JSON.parse(notification) : notification;

    //                     const wasAdded = await dispatch(tryAddNotification(parsed));
    //                     if (wasAdded) {
    //                         if (audioRef.current) {
    //                             audioRef.current.play().catch(() => { });
    //                         }
    //                         setIconVibrate(true);
    //                         toast.info("تحقق من الاشعارات!", {
    //                             position: "top-" + dir,
    //                             autoClose: 5000,
    //                             hideProgressBar: false,
    //                             closeOnClick: true,
    //                             pauseOnHover: true,
    //                             draggable: true,
    //                         });
    //                     } else {
    //                         console.log("ℹ️ الإشعار موجود مسبقًا:", parsed.NotifyId);
    //                     }

    //                 } catch (err) {
    //                     console.error("❌ Notification parse error:", err);
    //                 }
    //             });

    //             return connection;
    //         } catch (err) {
    //             console.error("❌ SignalR setup error:", err);
    //         }
    //     };

    //     let connection;
    //     setupConnection().then(conn => connection = conn);

    //     return () => {
    //         if (connection) connection.stop();
    //     };
    // }, [dir, dispatch]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open]);
    const testAddnotifications = (index) => {

        const testnotifications =
            { NotifyId: index, titleAr: index + "طلب جديد", contentAr: "لديك طلب جديد من أحمد", time: "منذ 5 دقائق", read: false };
        const parsed = typeof testnotifications === 'string' ? JSON.parse(testnotifications) : testnotifications;
        dispatch(addNotification(parsed));
        if (navigator.vibrate) navigator.vibrate(200);
        setIconVibrate(true);  // تفعيل الاهتزاز البصري عند وصول إشعار
        toast.info("تحقق من الاشعارات!", {
            position: "top-" + dir,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    // إعادة تعيين الاهتزاز البصري بعد فترة قصيرة
    useEffect(() => {
        if (iconVibrate) {
            const timeout = setTimeout(() => {
                setIconVibrate(false);
            }, 5000);  // استمرارية الاهتزاز لمدة ثانيتين
            return () => clearTimeout(timeout);
        }
    }, [iconVibrate]);
    const handleMarkAllAsRead = () => {
        dispatch(markAllAsRead());
        const allIds = notifications.map(n => n.NotifyId);
        saveAllReadNotifications(allIds);
    };

    const handleClearAll = () => {
        dispatch(clearNotifications());

    };

    function timeSince(dateString) {
        const now = new Date();
        const date = new Date(dateString);
        const seconds = Math.floor((now - date) / 1000);

        const intervals = [
            { label: 'سنة', seconds: 31536000 },
            { label: 'شهر', seconds: 2592000 },
            { label: 'يوم', seconds: 86400 },
            { label: 'ساعة', seconds: 3600 },
            { label: 'دقيقة', seconds: 60 },
            { label: 'ثانية', seconds: 1 },
        ];

        for (const interval of intervals) {
            const count = Math.floor(seconds / interval.seconds);
            if (count >= 1) {
                return `منذ ${count} ${interval.label}${count > 1 ? '' : ''}`;
            }
        }

        return 'الآن';
    }
    return (
        <div className="notification-container">
            <audio ref={audioRef} src="/sounds/notification.mp3" preload="auto" />
            {/* <button className="notification-button" onClick={() => testAddnotifications(unreadCount != null && unreadCount >= 0 ? (unreadCount + 1) : 1)}>Test</button> */}
            <button
                onClick={() => setOpen(true)}
                className={`notification-button`}
            >
                <div className={`bell-icon ${iconVibrate ? 'vibrate' : ''}`} tabIndex="0">
                    <svg
                        version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="30px" viewBox="0 0 50 30" enableBackground="new 0 0 50 30" xmlSpace="preserve"
                    >
                        <g className="bell-icon__group">
                            <path
                                className="bell-icon__ball" id="ball" fillRule="evenodd" strokeWidth="1.5" clipRule="evenodd" fill="none" stroke="currentColor" strokeMiterlimit="10" d="M28.7,25 c0,1.9-1.7,3.5-3.7,3.5s-3.7-1.6-3.7-3.5s1.7-3.5,3.7-3.5S28.7,23,28.7,25z"
                            />
                            <path
                                className="bell-icon__shell" id="shell" fillRule="evenodd" clipRule="evenodd" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10"
                                d="M35.9,21.8c-1.2-0.7-4.1-3-3.4-8.7c0.1-1,0.1-2.1,0-3.1h0c-0.3-4.1-3.9-7.2-8.1-6.9c-3.7,0.3-6.6,3.2-6.9,6.9h0
              c-0.1,1-0.1,2.1,0,3.1c0.6,5.7-2.2,8-3.4,8.7c-0.4,0.2-0.6,0.6-0.6,1v1.8c0,0.2,0.2,0.4,0.4,0.4h22.2c0.2,0,0.4-0.2,0.4-0.4v-1.8
              C36.5,22.4,36.3,22,35.9,21.8L35.9,21.8z"
                            />
                        </g>
                    </svg>
                    {unreadCount > 0 && (<div className={`notification-amount ${iconVibrate ? 'vibrate' : ''}`}>


                        <span >{unreadCount > 99 ? "+99" : unreadCount}</span>

                    </div>)}
                </div>
            </button>

            {open && <div className="notification-overlay" />}

            <div className={`notification-dropdown ${open ? "open" : ""}`} ref={dropdownRef}>
                <div className="notification-header flex items-center justify-between px-4 mb-4">
                    <p className="text-3xl text-primary font-medium cursor-pointer" onClick={() => handleClearAll()}>مسح الكل </p>
                    <p className="text-3xl text-primary font-medium cursor-pointer" onClick={() => handleMarkAllAsRead()}> الكل كمقروءة</p>
                </div>
                <div className={`notification-dropdown-container`}>


                    {notifications.length === 0 ? (
                        <div className="notification-empty">لا توجد إشعارات</div>
                    ) : (

                        <>
                            <ul className="divide-y divide-gray-300">
                                {notifications.map((item, index) => (
                                    <li
                                        key={index}
                                        className={`dropdown-item  notification-item p-4 flex items-center hover:bg-gray-50 cursor-pointer ${item.read ? 'read' : 'unread'}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(markAsRead(item.NotifyId));
                                            saveReadNotification(item.NotifyId);
                                            setOpen(false)
                                            history.push({
                                                pathname: `/user/notifications/`,
                                                search: ""
                                            });
                                        }}
                                    >
                                        <img src="/assets/user_profile/icons/notification/icon.svg" width={20} height={5}
                                            className="icon w-12 h-12 rounded-full shrink-0 mx-2" alt="notification" />
                                        <div className="w-90 ml-6">
                                            <h3 className="text-3xl item-title text-slate-900 font-semibold">
                                                {item.titleAr}
                                            </h3>
                                            <p className="text-2xl item-content text-slate-500 leading-relaxed mt-2">
                                                {item.contentAr}
                                            </p>

                                            <div className="w-100 flex items-center justify-between">
                                                <p className="text-xl text-primary font-medium leading-3 mt-5">{timeSince(item.createdDate)}</p>
                                                {!item.read && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            dispatch(markAsRead(item.NotifyId));
                                                            saveReadNotification(item.NotifyId);
                                                        }}
                                                        className="mt-2 btn-MarkRead text-xl text-primary font-medium cursor-pointer"
                                                    >
                                                        تحديد كمقروء
                                                    </button>
                                                )}
                                            </div>

                                        </div>
                                    </li>
                                ))}
                            </ul>


                        </>

                    )}

                    <p className="text-3xl px-4 mt-6 mb-4 text-center inline-block text-primary font-medium cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpen(false)
                            history.push({
                                pathname: `/user/notifications/`,
                                search: ""
                            });
                        }}
                    >
                        عرض جميع الاشعارات
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotificationComponent;
